var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptycart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 98.798,
    height: 94.035,
    viewBox: "0 0 98.798 94.035",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_03_Trolley",
    "data-name": "03 Trolley",
    transform: "translate(-14 -17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M47.25,83.5H96.93a4,4,0,0,0,3.86-3l9.87-37a4,4,0,0,0-3.86-5H42.88Z",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M48.1,92.51l-7-69.25A4.73,4.73,0,0,0,36.42,19H20.5a4.5,4.5,0,0,0,0,9H31.91l7.4,73.5H100v-9Z",
    fill: "#bebebe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M43.28,109a8.24,8.24,0,1,1,8.24-8.24A8.24,8.24,0,0,1,43.28,109ZM109,100.76a8.24,8.24,0,1,0-8.24,8.24A8.24,8.24,0,0,0,109,100.76Z",
    fill: "#5bc9e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M39.78,86.3,33.9,27.8a2,2,0,0,0-2-1.8H20.5c-3.3,0-3.3-5,0-5H36.42a2.73,2.73,0,0,1,2.72,2.46L42,51.51a2.01,2.01,0,0,0,4-.4L43.12,23.06A6.71,6.71,0,0,0,36.42,17H20.5a6.5,6.5,0,0,0,0,13h9.6l5.7,56.7a2,2,0,1,0,3.98-.4Z",
    fill: "#314967"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M50,40.5H88.79a2,2,0,0,0,0-4H50a2,2,0,0,0,0,4Z",
    fill: "#314967"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M106.79,36.5h-12a2,2,0,0,0,0,4h12a2,2,0,0,1,1.94,2.5L98.86,80a2,2,0,0,1-1.93,1.48H85.75a2,2,0,0,0,0,4H96.93a6,6,0,0,0,5.8-4.45l9.87-37a6,6,0,0,0-5.81-7.53Z",
    fill: "#314967"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M75,99.51H53.44a10.22,10.22,0,0,0-3.27-6.31l-.77-7.7H79a2,2,0,0,0,0-4H49l-2.42-24a2.01,2.01,0,0,0-4,.4l3.32,33a10.24,10.24,0,1,0,7.22,12.64H75a2.015,2.015,0,0,0,0-4.03ZM43.28,107a6.24,6.24,0,1,1,6.24-6.24A6.24,6.24,0,0,1,43.28,107Z",
    fill: "#314967"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M58.06,51.33V70.26a2,2,0,0,0,4,0V51.33a2,2,0,0,0-4,0Z",
    fill: "#314967"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M71.83,51.33V70.26a2,2,0,0,0,4,0V51.33a2,2,0,0,0-4,0Z",
    fill: "#314967"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M85.59,51.33V70.26a2,2,0,0,0,4,0V51.33a2,2,0,0,0-4,0Z",
    fill: "#314967"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M100,90.51H53.64a2,2,0,0,0,0,4h39a10.18,10.18,0,0,0-2.06,5H81a2,2,0,0,0,0,4h9.9a10.24,10.24,0,0,0,20.1-2.76C111,95.83,107.37,90.51,100,90.51Zm.76,16.49a6.24,6.24,0,1,1,6.24-6.24,6.24,6.24,0,0,1-6.24,6.24Z",
    fill: "#314967"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptycart);
export default __webpack_public_path__ + "static/media/emptycart.fc8a573ea717b94acea9bcb15557ee32.svg";
export { ForwardRef as ReactComponent };